import { format as originalFormat } from 'date-fns';
import { useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

import { GetGetFlightsResponse, KeyGetGetFlights, useMutationPutUpdateResourcesFlights } from '../../../../../backend';
import { errorToastConfig } from '../../../../../utils/utils';
import { useRmsGanttValue } from '../../RmsContext';
import { ganttDayFormat } from '../gantt.constants';
import { getTurnaroundId } from '../gantt.utils';

export function useUpdateTurnaround({ optimisticUpdate }: { optimisticUpdate: boolean }) {
    const resourceType = useRmsGanttValue('resourceType');
    const queryClient = useQueryClient();
    const day = useRmsGanttValue('day');
    const {
        mutateAsync: updateAsyncFlights,
        mutate: updateFlights,
        isLoading,
    } = useMutationPutUpdateResourcesFlights({
        //to avoid delay in updated flight display
        onMutate: async request => {
            if (optimisticUpdate) {
                // Snapshot the previous value
                const queryKey = [
                    KeyGetGetFlights,
                    {
                        selectedDay: originalFormat(day, ganttDayFormat),
                        selectedResourceType: resourceType,
                    },
                ];

                await queryClient.cancelQueries(queryKey);

                // Snapshot the previous value
                const previousResponse = queryClient.getQueryData(queryKey, { exact: false });

                // TODO Probably stuff here
                queryClient.setQueriesData(
                    { queryKey: queryKey },
                    (response: GetGetFlightsResponse): GetGetFlightsResponse => ({
                        ...response,
                        data: {
                            ...response.data,
                            turnarounds: response.data.turnarounds.map(t =>
                                // find the exact same turnaround
                                getTurnaroundId(t) === getTurnaroundId(request.flightsUpdateDto.turnaround) &&
                                t.considerArrivalFlight === request.flightsUpdateDto.turnaround.considerArrivalFlight &&
                                t.considerDepartureFlight ===
                                    request.flightsUpdateDto.turnaround.considerDepartureFlight
                                    ? request.flightsUpdateDto.turnaround
                                    : t,
                            ),
                        },
                    }),
                );

                return { previousResponse };
            }
        },
        onSuccess: response => {
            queryClient.setQueriesData(
                {
                    queryKey: [
                        KeyGetGetFlights,
                        {
                            selectedDay: originalFormat(day, ganttDayFormat),
                            selectedResourceType: resourceType,
                        },
                    ],
                },
                response,
            );
        },
        onError: (err, newTodo, context: any) => {
            toast(err?.message, errorToastConfig);
            if (optimisticUpdate) {
                queryClient.setQueriesData(
                    {
                        queryKey: [
                            KeyGetGetFlights,
                            {
                                selectedDay: originalFormat(day, ganttDayFormat),
                                selectedResourceType: resourceType,
                            },
                        ],
                    },
                    context.previousResponse,
                );
            }
        },
    });

    return { updateAsyncFlights, updateFlights, isLoading };
}
